import React, { useContext } from 'react';
import { Modal } from 'semantic-ui-react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import { AppState } from 'services/types';
import { updateQueryString as updateQueryStringAction } from 'services/router/actions';
// @ts-ignore
import { selectActiveTableCellRowIds } from 'services/selectedTableCells/selectors';
import { VirtualizedTableItemKey } from 'services/virtualizedTable/types';
import {
    makeSelectQueryStringValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

import { VirtualizedTableContextProviderValue } from '../../types';
import VirtualizedTableDeleteFormWrapper from '../VirtualizedTableDeleteFormWrapper';
import VirtualizedTableContext from '../VirtualizedTableContext';
import { DELETE_MODAL_QUERY_STRING_PARAM } from '../../constants';

interface ConnectedProps {
    queryStringValue: ReturnType<ReturnType<typeof makeSelectQueryStringValue>>;
    activeItemKeys: VirtualizedTableItemKey[];
}

interface DispatchProps {
    updateQueryString: typeof updateQueryStringAction;
}

type Props = ConnectedProps & DispatchProps;

export const VirtualizedTableDeleteModalComponent = (
    props: Props
): React.ReactElement => {
    const {
        activeItemKeys,
        queryStringValue,
        updateQueryString: updateQS
    } = props;
    const {
        label,
        labelPlural
    }: VirtualizedTableContextProviderValue = useContext(
        VirtualizedTableContext
    );

    React.useEffect(() => {
        if (queryStringValue && !activeItemKeys.length) {
            updateQS({
                [DELETE_MODAL_QUERY_STRING_PARAM]: undefined
            });
        }
    }, [queryStringValue, activeItemKeys, updateQS]);

    const handleClose = (): void => {
        props.updateQueryString({
            [DELETE_MODAL_QUERY_STRING_PARAM]: undefined
        });
    };

    const itemLabel =
        activeItemKeys.length === 1 ? label || 'item' : labelPlural || 'items';

    return (
        <Modal
            size="tiny"
            open={!!queryStringValue}
            centered={false}
            onClose={handleClose}
            closeIcon
        >
            <React.Fragment>
                <Modal.Header>Delete {itemLabel}</Modal.Header>
                <Modal.Content>
                    <VirtualizedTableDeleteFormWrapper />
                </Modal.Content>
            </React.Fragment>
        </Modal>
    );
};

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    queryStringValue: makeSelectQueryStringValue(
        DELETE_MODAL_QUERY_STRING_PARAM
    ),
    activeItemKeys: selectActiveTableCellRowIds
});

export default connect(mapStateToProps, {
    updateQueryString: updateQueryStringAction
})(VirtualizedTableDeleteModalComponent);
